import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import moment from "moment";
import {Checkbox} from "antd";

import {api} from "../../../../services";
import DetailItem from "./DetailItem";
import {WarningIcon} from "../../../../common/icons";
import AirButton from "../../../../common/components/AirButton";
import PositionsDetail from "./PositionsDetail";

import './TripItem.css'
import NoteInput from "./NoteInput";

@inject('translationsStore', 'tripsStore', 'commonStore')
@observer
export default class TripItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crashEvents: 0,
      overRpmsCount: 0
    }
  }

  componentDidMount() {
    this.setCrashEvents();
    this.setOverRpms();
  }

  setCrashEvents = () => {
    const {
      trip: { startAt, endAt, car }
    } = this.props;
    const startTime = startAt ? startAt : new Date().toISOString(),
      endTime = endAt ? endAt : new Date().toISOString();
    let crashEvents;
    api('getCarCrashEvents', car.plate, startTime, endTime)
      .then(response => {
        crashEvents = response.count;
      })
      .catch(() => {
        crashEvents = 0;
      })
      .finally(() => {
        this.setState({ crashEvents });
      });
  };

  setOverRpms = () => {
    const {
      trip: { startAt, endAt, car }
    } = this.props;
    api('getRpm', this.props.trip.carId, moment(startAt).format('YYYY-MM-DD'), moment(endAt ? endAt : startAt).format('YYYY-MM-DD'))
      .then(rawOverRpms => {
        return rawOverRpms;
      })
      .catch(() => {})
      .then(rawOverRpms => {
        const overRpmsCount = rawOverRpms.rpms.filter(rpm => rpm.startDateTime >= startAt && rpm.endDateTime <= endAt);
        this.setState({
          overRpmsCount: overRpmsCount
        });
      });
  }

  getAlarmsCount = () => {
    const {trip} = this.props;
    return (
      Number(trip.accelerations) +
      Number(trip.brakes) +
      Number(trip.leftTurns) +
      Number(trip.rightTurns) +
      Number(trip.overDrives) +
      Number(this.state.overRpmsCount) +
      Number(this.state.crashEvents)
    );
  }

  handleNoteChange = (note) => {
    const trip = {...this.props.trip, note};
    this.props.tripsStore.updateTrip(trip)
  }

  render() {
    const {trip, translationsStore, tripsStore, commonStore} = this.props;

    return (
      <div className={`TripItem${tripsStore.selectedTrips.length > 0 && !tripsStore.isTripSelected(trip.id) ? ' disabled' : ''}`}>
        <div className="TripTitle">
          <div className="TripDate">
            <Checkbox style={{marginRight: 10}} onChange={() => tripsStore.toggleSelection(trip.id)} checked={tripsStore.isTripSelected(trip.id)} />
            {`${new Date(trip.startAt).toLocaleDateString()} (${new Date(trip.startAt).toLocaleTimeString([], {timeStyle: 'short'})}${trip.endAt ? ` - ${new Date(trip.endAt).toLocaleTimeString([], {timeStyle: 'short'})}` : ''})`}
          </div>
          <NoteInput value={trip.note} onChange={this.handleNoteChange} />
        </div>
        <div className="TripDetails">
          <PositionsDetail trip={trip} />
          <DetailItem label={translationsStore.translate('tripsList.detail.time')} value={moment.duration(trip.duration || 0, 'seconds').format('h:mm:ss [h]', { trim: false })} />
          <DetailItem label={translationsStore.translate('tripsList.detail.distance')} value={`${trip.distance} km`} />
          <DetailItem label={translationsStore.translate('tripsList.detail.vehicle')} value={trip.car.plate} />
          <DetailItem label={translationsStore.translate('tripsList.detail.alerts')} value={<div style={{color: '#ff5d58', display: 'flex'}}><WarningIcon style={{fontSize: 18, marginRight: 5}} />{this.getAlarmsCount()}</div>} />
          <AirButton size="large" light="true" className="TripDetailButton" label={translationsStore.translate('tripsList.detail.detailButton')} onClick={() => tripsStore.setSelectedDetailTrip(trip)} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/TripItem.js